import { render, staticRenderFns } from "./DownloadTask.vue?vue&type=template&id=cbb7a18e"
import script from "./DownloadTask.vue?vue&type=script&lang=js"
export * from "./DownloadTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports